import { getRequest } from '../../../../../services/httpService';

export interface BillingService {
  id: number;
  name: string;
  code: string;
  category: string;
  source: string;
  service_type: string;
  source_type?: string;
  procedure: string | null;
  charges?: string | null;
  discount_amount?: string | null;
  discount_percent?: string | null;
  is_from_package?: boolean;
  package_id?: number | null;
  package_name?: string | null;
  package_service_rates?: Array<{
    package: number;
    name: string;
    unit_rate: number;
    discount_amount: number;
    discount_percent: number;
    is_consumables: boolean;
    unlimited_quantity: boolean;
    adjustable_head?: boolean;
    adjustable_head_type?: string | null;
  }>;
  provider?: number | string | null;
  provider_id?: number | null;
}

export function getBillingSearchServicesUrl(
  category: string = '',
  search: string = '',
  patientId?: string | number,
  tariffId?: string | number
): string {
  const params = new URLSearchParams();
  params.set('category', category );
  params.set('search_query', search || '');
  if (patientId) {
    params.set('patient_id', String(patientId));
  }
  if (tariffId) {
    params.set('tariff_id', String(tariffId));
  }

  return `billing/search-services/?${params.toString()}`;
}

export function fetchBillingSearchServices(
  category: string = '',
  search: string = '',
  patientId?: string | number,
  tariffId?: string | number
): Promise<BillingService[]> {
  return getRequest<BillingService[]>(
    getBillingSearchServicesUrl(category, search, patientId, tariffId),
    { responseType: 'json' }
  );
}
